import React from "react";

const SvgCancer = (props) => {
  return (
    <svg
      viewBox="0 0 33.54 28.2"
      width="1em"
      height="1em"
      {...props}
    >
      <style>{`.cancer_svg__st0{fill-rule:evenodd;clip-rule:evenodd}`}</style>
      <path
        className="cancer_svg__st0"
        d="M30.91 18.7c-3.73 4.19-8.79 6.5-14.24 6.5-2.53 0-5.01-.53-7.32-1.52 2.2-1.06 3.73-3.3 3.73-5.9 0-3.61-2.93-6.54-6.54-6.54S0 14.18 0 17.79c0 1.74.69 3.33 1.81 4.5.04.05.06.11.11.15.12.11.24.2.36.3.07.06.14.12.21.17 4 3.4 9 5.29 14.19 5.29 6.23 0 12.24-2.74 16.48-7.51.55-.62.5-1.57-.12-2.12-.63-.54-1.57-.49-2.13.13zM6.54 14.24c1.95 0 3.54 1.59 3.54 3.54s-1.59 3.54-3.54 3.54A3.532 3.532 0 013 17.79c0-1.96 1.59-3.55 3.54-3.55z"
      />
      <path
        className="cancer_svg__st0"
        d="M1.5 10c.41 0 .83-.17 1.12-.5C6.35 5.31 11.41 3 16.86 3c2.53 0 5.01.53 7.32 1.52a6.545 6.545 0 00-3.73 5.9c0 3.61 2.93 6.54 6.54 6.54s6.54-2.93 6.54-6.54c0-1.75-.69-3.33-1.81-4.5-.04-.05-.06-.11-.11-.15-.12-.1-.24-.19-.36-.3-.07-.06-.14-.12-.21-.17-4-3.4-9-5.29-14.19-5.29C10.63 0 4.62 2.74.38 7.51c-.55.61-.5 1.56.12 2.11.29.26.65.38 1 .38zm25.49 3.96c-1.95 0-3.54-1.59-3.54-3.54s1.59-3.54 3.54-3.54 3.54 1.59 3.54 3.54c.01 1.95-1.58 3.54-3.54 3.54z"
      />
    </svg>
  );
};

export default SvgCancer;
